module.exports = __webpack_public_path__ + "img/hr-tree-01-d-leaves.bee96aa1.png";